export default __webpack_public_path__ + "static/g-02-b3238bae9b40b5bee567267c7afafcd5.png";